import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-accordioncontent',
  content: 'p-accordioncontent-content'
};
var AccordionContentStyle = BaseStyle.extend({
  name: 'accordioncontent',
  classes: classes
});

export { AccordionContentStyle as default };
//# sourceMappingURL=index.mjs.map
